<template>
  <div class="single-question">
    <div
      ref="describe"
      style="position:relative;left:0;transition: left 0.5s,opacity 0.5s;"
    >
      <!-- 题干 -->
      <div
        v-if="question.questionStem"
        class="describe"
      >
        <img
          class="robot"
          src="../assets/image/test-robot-photo.png"
          alt=""
        >
        <div class="box-contain">
          <div class="subject-content">
            <div class="subject-content-bg" />
            {{ question.questionStem }}
          </div>
        </div>
      </div>
      <!-- 题目图片 -->
      <div
        v-if="question.gaugeFileDTOList && question.gaugeFileDTOList.length>0"
        class="image-list-contain"
      >
        <div
          v-for="item, number in question.gaugeFileDTOList"
          :key="number"
          class="describe"
        >
          <img
            class="robot"
            src="../assets/image/test-robot-photo.png"
            alt=""
          >
          <div class="image-contain">
            <!-- <img class="image-css" src="../assets/images/report-background3.png" alt=""> -->
            <img
              class="image-css"
              :src="item.filePath"
              alt=""
            >
          </div>
        </div>
      </div>
      <!-- 题目相关信息 -->
      <div class="describe">
        <img
          class="robot"
          src="../assets/image/test-robot-photo.png"
          alt=""
        >
        <div class="box-contain">
          <div class="subject-content">
            <div class="subject-content-bg" />
            <div class="question-text">
              {{ question.questionName }}
            </div>
          </div>
          <div
            v-if="showAnswerList"
            class="question-subject-content"
          >
            <ul class="single-select-group">
              <li
                v-for="item in question.answerList"
                :key="item.businessId"
                class="single-select-item"
              >
                <p
                  class="active-text"
                  @click="newSelectAaswer(item)"
                >
                  {{ item.optionName }}
                </p>
              </li>
            </ul>
          </div>
          <!-- <div
            v-if="showEditLastQuestion"
            style="display:flex;flex-direction: row-reverse;"
          >
            <p
              class="edit-last-question"
              @click="newModilyLastQuestion"
            >
              <img
                src="../assets/image/edit-last-question.png"
                alt=""
              >
              <span>修改上一题>></span>
            </p>
          </div> -->
        </div>
      </div>
    </div>

    <div
      v-if="showAnswer"
      ref="answerContain"
      class="answer-contain"
    >
      <div class="answer">
        <img
          class="user-photo"
          :src="defaultUserPhoto"
          alt=""
        >
        <div class="sing-answer-item">
          {{ answerText }}
        </div>
      </div>
    </div>
    <div
      v-if="showRobotAnswer"
      ref="robotAnswerContain"
      class="robot-answer-reply marginTop17"
    >
      <img
        class="robot"
        src="../assets/image/test-robot-photo.png"
      >
      <div class="robot-answer-item marginLeft13">
        <div class="subject-content-bg" />
        {{ robotReplyText }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { saveGaugeEvaluationRecord, getGaugeEvaluationRecord, deleteLastQuestionCache } from "@/assets/utils.js"
export default {
  props: {
    index: {
      type: Number,
      default: 0
    },
    gaugeId: {
      type: String,
      default: '1'
    },
    taskId: {
      type: String,
      default: '1'
    },
    versionNum: {
      type: Number,
      default: 0
    },
    question: {
      type: Object,
      default: () => { }
    },
    evaluationRecordId: {
      type: String,
      default: '1'
    }
  },
  data () {
    return {
      activeSelectId: '',
      selectList: [
        {
          id: '1',
          text: '完全没有'
        },
        {
          id: '2',
          text: '有一点'
        },
        {
          id: '3',
          text: '比较大'
        },

      ],
      showRobotAnswer: false,
      isDisabled: false,
      showAnswer: false,
      answerText: '',
      showEditLastQuestion: false,
      robotReplyText: '',
      showOthers1: false, // 另类的答案提示语，并且有交互
      activeOtherAnswer: false,
      showOthers2: false,
      answerObj: {},
      defaultUserPhoto: require("../assets/image/teacher-nv.png"),
      answerQuestionStartTime: '',
      disableModify: false,
      showAnswerList: true
    }
  },
  computed: {
    ...mapState(['userInfo']),
    insideRecordId () { // 本次测评的测评id
      return this.evaluationRecordId
    }
  },
  created () {
    if (this.question.answerInfo && this.question.answerInfo.length > 0) { // 有答案，直接显示答案
      this.isDisabled = true
      this.showAnswerList = false
      this.answerText = this.question.answerInfo[0].optionName
      this.activeSelectId = this.question.answerInfo[0].businessId
      this.showAnswer = true
      if (this.question.answerInfo[0].optionAnswer && this.question.answerInfo[0].optionAnswer.length > 0) {
        this.robotReplyText = this.question.answerInfo[0].optionAnswer
        this.showRobotAnswer = true
      }
    } else {  // 没有答案记录开始答题时间
      this.answerQuestionStartTime = new Date().getTime()
    }
  },
  methods: {
    // 缓存答案---保存学习机本地
    newSelectAaswer (item) {
      if (this.isDisabled) {
        return
      }
      this.isDisabled = true // 禁止再次点击
      this.activeSelectId = item.businessId
      let data = JSON.parse(JSON.stringify(this.question))
      data.answerInfo = [item]
      let recode = getGaugeEvaluationRecord("", this.gaugeId + "_" + this.versionNum, this.taskId)
      if (this.question.questionNo === 1 || (recode && recode.recordList && (recode.recordList.length + 1 === this.question.questionNo))) {
        saveGaugeEvaluationRecord("", this.gaugeId + "_" + this.versionNum, data, 1, this.taskId)
      } else {
        this.$emit("restart")
        return
      }
      this.answerObj = item
      this.answerText = item.optionName
      setTimeout(() => {
        this.showAnswerList = false
        this.showAnswer = true
        this.$nextTick(() => {
          this.$parent.scollButtomAnimation()
          setTimeout(() => {
            this.showEditLastQuestion = true
          })
          if (item.optionAnswer && item.optionAnswer.length > 0) { // 答案有交互语
            this.robotReplyText = item.optionAnswer
            this.showRobotAnswer = true
            this.$nextTick(() => {
              this.$parent.scollButtomAnimation()
              this.$emit("loadNextQuestion", {
                index: this.index,
                answerIds: [this.answerObj]
              })
            })
          } else {
            this.$emit("loadNextQuestion", {
              index: this.index,
              answerIds: [this.answerObj]
            })
          }
        })
      }, 500)
    },
    // 修改上一题--从缓存中删除最后一题的答案
    newModilyLastQuestion () {
      if (this.disableModify) {
        return
      }
      this.disableModify = true
      // 禁止下一题的点击事件
      this.$emit("banNextQuestionAnswer", {
        index: this.index
      })
      let recode = getGaugeEvaluationRecord("", this.gaugeId + "_" + this.versionNum, this.taskId)
      if (recode && recode.recordList && recode.recordList.length > 0) {
        deleteLastQuestionCache("", this.gaugeId + "_" + this.versionNum, this.taskId)
      } else {
        this.$emit("restart")
        return
      }
      // deleteLastQuestionCache("", this.gaugeId + "_" + this.versionNum, this.taskId)
      this.activeSelectId = ""
      this.showEditLastQuestion = false
      setTimeout(() => {
        if (this.showRobotAnswer) {
          this.$refs.robotAnswerContain.style.left = '-120%'
          this.$refs.robotAnswerContain.style.opacity = '0'
          this.showRobotAnswer = false
        }
        this.$refs.answerContain.style.left = '120%'
        this.$refs.answerContain.style.opacity = '0'
        // this.showEditLastQuestion = false
      }, 0)
      setTimeout(() => {
        this.isDisabled = false
        this.showEditLastQuestion = false
        this.showAnswer = false
      }, 600)
      this.$emit("modifyLastQuestuon", {
        index: this.index,
        answerIds: this.question.questionId,
        dimensionId: this.question.dimensionId
      })
      this.disableModify = false
    },
    // 确定答案
    async selectAnswer (item) {
      if (this.isDisabled) {
        return
      }
      this.answerObj = item
      this.isDisabled = true // 禁止再次点击
      this.activeSelectId = item.businessId
      // 保存答案操作
      try {
        const res = await this.$api.saveEvalRecord({
          taskId: this.taskId,
          gaugeId: this.gaugeId,
          questionId: this.question.questionId,
          questionName: this.question.questionName,
          answerList: [this.answerObj],
          questionNo: this.question.questionNo,
          evaluationRecordId: this.evaluationRecordId || this.insideRecordId,
          answerTime: new Date().getTime() - this.answerQuestionStartTime,
          deleted: 0, // 存题答案是0, 删除题目答案是1
        });
        if (res.close) {
          this.$router.push("/home")
          return
        }
        this.answerText = item.optionName
        this.showAnswer = true
        this.$nextTick(() => {
          this.$parent.scollButtomAnimation()
          setTimeout(() => {
            this.showEditLastQuestion = true
          })
          if (item.optionAnswer && item.optionAnswer.length > 0) { // 答案有交互语
            this.robotReplyText = item.optionAnswer
            this.showRobotAnswer = true
            this.$nextTick(() => {
              this.$parent.scollButtomAnimation()
              this.$emit("loadNextQuestion", {
                index: this.index,
                answerIds: [this.answerObj]
              })
            })
          } else {
            this.$emit("loadNextQuestion", {
              index: this.index,
              answerIds: [this.answerObj]
            })
          }
        })
      } catch (err) {
        // console.log(err)
        this.isDisabled = false
        this.activeSelectId = ''
      }
    },
    // 修改上一题
    async modilyLastQuestion () {
      if (this.disableModify) {
        return
      }
      this.disableModify = true
      try {
        await this.$api.saveEvalRecord({
          questionId: this.question.questionId,
          evaluationRecordId: this.evaluationRecordId || this.insideRecordId,
          questionNo: this.index,
          deleted: 1, // 存题答案是false, 删除题目答案是true
        });
        this.activeSelectId = ""
        this.showEditLastQuestion = false
        setTimeout(() => {
          if (this.showRobotAnswer) {
            this.$refs.robotAnswerContain.style.left = '-120%'
            this.$refs.robotAnswerContain.style.opacity = '0'
            this.showRobotAnswer = false
          }
          this.$refs.answerContain.style.left = '120%'
          this.$refs.answerContain.style.opacity = '0'
          // this.showEditLastQuestion = false
        }, 0)
        setTimeout(() => {
          this.isDisabled = false
          this.showEditLastQuestion = false
          this.showAnswer = false
        }, 600)
        this.$emit("modifyLastQuestuon", {
          index: this.index,
          answerIds: this.question.questionId,
          dimensionId: this.question.dimensionId
        })
        this.disableModify = false
      } catch (error) {
        this.disableModify = false
      }
    },
    // 移除动画
    startMoveAnimation () {
      this.$refs.describe.style.left = '-120%'
      this.$refs.describe.style.opacity = '0'
    },
  }
}
</script>

<style lang="scss" scoped>
.single-question {
  position: relative;
  .marginTop17 {
    margin-top: 30px;
  }
  .marginLeft13 {
    margin-left: 24px;
  }
  .describe,
  .guide-language,
  .robot-answer-reply {
    position: relative;
    left: 0;
    opacity: 1;
    display: flex;
    margin-top: 30px;
    transition: left 0.5s, opacity 0.5s;
    .robot {
      width: 80px;
      height: 80px;
      // background: pink;
      border-radius: 50%;
    }
    .image-css {
      width: 100%;
      // height: 305px;
      border-radius: 16px;
    }
    .image-contain {
      min-width: 350px;
      max-width: 450px;
      margin-left: 24px;
      border-radius: 16px;
      border: 1px solid #dadef1;
      box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.02);
      overflow: hidden;
    }
    &:first-child {
      margin-top: 0px;
    }
  }
  .box-contain {
    // margin-left: 13px;
    width: 100%;
    font-size: 17px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 26px;
  }
  .single-select-group {
    // max-width: 1355px;
    display: flex;
    flex-wrap: wrap;
    justify-content: safe center;
    // justify-items: center;
    margin-top: 10px;
    .single-select-item {
      padding: 20px 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 48px;
      .select-icon {
        width: 40px;
        height: 40px;
        margin-right: 16px;
      }
      p {
        // width: 100%;
        height: 100%;
        padding: 20px 32px;
        box-sizing: border-box;
        border-radius: 50px;
        box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.02);
        border-radius: 50px;
        border: 1px solid #00baff;
        color: #00baff;
      }
      .active-text {
        background: linear-gradient(300deg, #007fff 0%, #00b1ff 100%);
        border: none;
        color: #ffffff;
        font-size: 32px;
        color: #ffffff;
        line-height: 45px;
      }
    }
    .active-single-item {
      color: #262626;
      background: #ecf7ff;
      border: 1px solid #ecf7ff;
    }
  }
  .sing-answer-item {
    margin-right: 24px;
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.02);
    border: 1px solid #00baff;
    border-radius: 24px 0 24px 24px;
    padding: 20px 32px;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    background: linear-gradient(300deg, #007fff 0%, #00b1ff 100%);
    min-width: 185px;
  }
  .robot-answer-item {
    max-width: 1255px;
    box-sizing: border-box;
    margin-right: 24px;
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.02);
    border-radius: 0px 24px 24px 24px;
    padding: 20px 32px;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    min-width: 185px;
    position: relative;
    overflow: hidden;
    .subject-content-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background: #ffffff;
      opacity: 0.2;
    }
  }
  .image-list-contain {
    margin-top: 30px;
    &:first-child {
      margin: 0;
    }
  }
}
</style>